package com.jingfangpai.common.coroutines

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.MainScope

public actual fun customMainScope(): CoroutineScope = MainScope()
